<template>
    <q-card class="full-height bg-white">
        <q-card-title class="text-center bg-primary text-white">
            {{ $t('surveys') }}
        </q-card-title>

        <q-card-separator />

        <q-card-main class="relative-position full-height">
            <q-list class="survey-title" v-if="surveys">
                <q-collapsible multiline dense :label="survey.title" :sublabel="`${$t('questions')}: ${survey.survey_questions.length}`" icon="far fa-check-square" v-for="(survey, index) in surveys" :key="index" group="surveys" v-if="surveys">
                    <div class="row gutter-sm">
                        <div class="col-12 text-faded">
                            <span v-html="survey.description"></span>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-sm">
                        <div class="col-xs-12 col-sm-4">
                            <q-btn color="secondary" class="full-width" :label="$t('answer')" icon="fas fa-check" @click="answerSurvey(survey)" />
                        </div>
                    </div>
                </q-collapsible>

                <q-collapsible dense :label="$t('no_survey_avaliable')" icon="far fa-check-square" group="surveys" v-if="surveys.length === 0" disable>
                </q-collapsible>
            </q-list>
        </q-card-main>

        <surveys :show="show" :survey_id="survey_id" @hide_survey="hideSurvey" />
    </q-card>
</template>

<script>
import Surveys from 'components/authenticated/OptionalSurvey'

export default {
    props: ['surveys'],

    components: {
        'surveys': Surveys
    },

    data() {
        return {
            show: false,
            survey_id: ''
        }
    },

    methods: {
        answerSurvey(survey) {
            this.survey_id = survey.id
            this.show = true
        },

        hideSurvey() {
            this.show = false
            this.survey_id = ''
            this.$emit('reload_surveys')
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>
